import React, { useEffect, useState } from "react";
import InnerImageZoom from 'react-inner-image-zoom';
import 'react-inner-image-zoom/lib/InnerImageZoom/styles.css';
import Box from '@mui/material/Box';
import {computeResize} from '../ProgressiveImage';
import { useTheme } from '@mui/material/styles';


export function ImageZoom({media, modalFigcaption = null, hasNavigation = false}) {

    const [mediaHeight, setMediaHeight] = useState(null);
    const [mediaWidth, setMediaWidth] = useState(null);
    const zoomScale = media.zoomScale ? media.zoomScale : 1.3;
    const alt = media.alt ? media.alt : (modalFigcaption ? modalFigcaption : null);
    const modalPaddingY = hasNavigation ? 156 : 136;
    const theme = useTheme();

    useEffect(() => {
        
        const handleResize = () => {
            if(window.innerWidth >= theme.breakpoints.values.lg) {
                if (window.innerHeight && media.width && media.height) {
                    const [width, height] = computeResize(media.width, media.height, window.innerHeight - modalPaddingY);
                    setMediaWidth(width);
                    setMediaHeight(height);
                }
            }
        }
        handleResize();
        window.addEventListener('resize', handleResize());
        return () => {
            window.removeEventListener('resize', handleResize());
        }
    });


    return (
        <>
        <Box sx={{ 
            maxHeight:"100%",
            overflow:"hidden!important",
            "& > *":{overflow:"hidden!important",maxHeight:"100%"},
        }}>
        <InnerImageZoom 
        src={media.src}
        zoomSrc={media.src}
        zoomScale={zoomScale}
        maxHeight={mediaHeight - 280}  
        maxWidth={mediaWidth}
        hideHint={true}
        hasSpacer={true}
        moveType="pan"
        alt={alt}
        />
        </Box>
        </>
    )
}

export function ModalZooms(props) {
    
    const medias = props.content.medias;
    const modalFigcaption = props.modalFigcaption ? props.modalFigcaption : null;
    
    // frameStyle() is a Patch for 1 exception (id 43)
    const frameStyle = () => {
        var frameStyle = "bg-[#f3f4f6] p-[12px] sm:p-[24px]";
        if(props.id === 43) {
            frameStyle = "bg-transparent p-0";
        }
        return frameStyle;
    }

   return (
    <figure className={`text-center flex flex-col md:flex-row md:justify-center mx-auto overflow-hidden`}>
        <div className={`flex flex-col md:flex-row md:justify-center mx-auto overflow-hidden sm:gap-[24px] ${frameStyle()}`}>
        {medias && medias.map((media) => {
            return (
            <ImageZoom key={media.src} media={media} modalFigcaption={modalFigcaption} sx={{overflow:"hidden"}} />
            )
        })}
        </div>
    </figure>
    )
}